$(document).ready(function() {
	if(!document.querySelector('.GPC0149')) return false;
	var compressorMotor={
			form: document.querySelector('.GPC0149 form.compressorMotor-form'),
			resultWrap : document.querySelectorAll('.GPC0149 .table-list'),
			localeCode : $('.GPC0149 form.compressorMotor-form #localeCode').val(),
			getData : new Array(),
			listAmountDefault: 5,
			thisLine : 5,
			pcIdx: 0,
			mobileIdx: 0,
			html : $(),
			mobileHtml: $(),
			init: function(){
				result.data();
				compressorMotor.paginationEvent();
				compressorMotor.addEvent();
			},
			submit: function(url, param){
				ajax.call(url, param, 'json', function(data){
					result.data (data, compressorMotor.thisLine);
					compressorMotor.paginationEvent();
				}, 'post', 'body');
			},
			addEvent: function(){
				var $formRoot = $(compressorMotor.form);
				$formRoot.on('submit', function(e){
					compressorMotor.pcIdx = 1;
					compressorMotor.mobileIdx = 1;
	            	result.currentIdx = 1;
	            	$("#from").val(1);
	            	
					e.preventDefault();
					var url = $formRoot.attr('data-url');
					var param = $formRoot.serialize();
					compressorMotor.submit(url, param);
				});
				$('.expander .btn').on('click',function(){
					compressorMotor.listAmountDefault = compressorMotor.listAmountDefault + 5;
					compressorMotor.thisLine = compressorMotor.listAmountDefault;
					$("#size").val(compressorMotor.thisLine);
					$formRoot.submit();
				});
				$('.compressorMotorDownload').on('click',function(){
					var fseqno = $(e.currentTarget).data('fseqno');
					$.ajax({
						method: 'get',
						url: '/'+compressorMotor.localeCode+'/mkt/ajax/compressorMotor/download/update',
						async: false,
						data: 'fSeqNo='+fseqno,
						dataType: "json",
						success: function() {
							//console.log('success');
						},
						error: function(request, status, error) {
							//console.log(request);
						}
					});
				});
			},
			paginationEvent : function(){
				result.$pgUl.find('button').off('click').on( 'click', function(e){
					e.preventDefault();
					var $this = $(this);
					result.currentIdx = Number($this.val()); // 3
					var page = (result.currentIdx * compressorMotor.thisLine) - compressorMotor.thisLine;
				
					compressorMotor.pcIdx =  page;
					$this.addClass('active').attr({'aria-label': 'page '+ result.currentIdx, 'aria-current': 'page' }).prop('disabled', true).parent('li').siblings('li').find('button').removeClass('active').removeAttr('aria-current').prop('disabled', false);
					$('.data-current-page').text($this.val());

					$("#from").val(result.currentIdx);
					var $evForm = $(compressorMotor.form);
					var url = $evForm.attr('data-url');
					var param = $evForm.serialize();
					compressorMotor.submit(url, param);
				});
				result.$pgWrap.find('.next, .prev').off('click').on( 'click', function(e){
					e.preventDefault();
					var isNext = $(this).is('.next');
					if ( isNext ) {
						result.currentIdx = Number(result.$pgUl.find('button').first().val()) + 5;
					} else {
						if( Number(result.$pgUl.find('button').first().val()) - 5 < 1){
							result.currentIdx = 1;
						}else{
							result.currentIdx = Number(result.$pgUl.find('button').first().val()) - 5;
						}
						
					}
					var page = (result.currentIdx * compressorMotor.thisLine) - compressorMotor.thisLine;
					compressorMotor.pcIdx =  page;
					result.listShow(compressorMotor.getData, (compressorMotor.pcIdx + compressorMotor.thisLine) );
					result.pagination();
					compressorMotor.paginationEvent();
					$('.data-current-page').text(result.$pgUl.find('button').first().val());
					
					$("#from").val(result.currentIdx);
					var $evForm = $(compressorMotor.form);
					var url = $evForm.attr('data-url');
					var param = $evForm.serialize();
					compressorMotor.submit(url, param);
				});
			}
	}
	var result = {
			currentIdx : 1,
			$pgWrap : $('.pagination-wrap'),
			$pgUl : $('.pagination-wrap .pagination ul'),
			getTotalNum : null,
			data : function (data, listAmount) {
				totalNum = $(compressorMotor.form).find("#toCnt").val();
				result.resogetTotalNum = totalNum;
				if(data!=undefined){
					data = data.compressorMotorResourceList;
					result.listShow(data, listAmount, totalNum);
					compressorMotor.getData = data;
				}else{
					listAmount = compressorMotor.thisLine;
				}
				compressorMotor.thisLine = listAmount;
				var $list = $(compressorMotor.resultWrap);
				result.pagination();
				
				$list.find('.no-content').removeClass('air-show');
				$list.find('.hidden-mobile, .visible-mobile, .pagination-wrap').removeClass('air-hidden');
				// no-content
				// console.log('totalNum  ', totalNum);
				if( (totalNum === 0) || ( totalNum === undefined ) ){
					$list.find('.hidden-mobile, .visible-mobile, .pagination-wrap').addClass('air-hidden');
					$list.find('.no-content').addClass('air-show');
				}
			},
			pagination : function(){
				var $pgWrap	= result.$pgWrap,
					$pgUl	= result.$pgUl,
					$htmlLi	= $(),
					//data = conditionSelect.getData,
					pageLength = Math.floor((result.resogetTotalNum-1) / compressorMotor.thisLine) + 1,
					i = result.currentIdx,
					f = result.currentIdx,
					v = 1,
					i2= 1;
					//v = result.currentIdx + 4;
				
					i = i - (i % 5) + ( (i % 5)==0?-4:1);
					v = i+4;
					i2 = i;

				//console.log("pageLength >> "+pageLength);
				//console.log("thisLine >> "+conditionSelect.thisLine);
				for(i;i<=pageLength;i++){
					if(i <= v ) {
						if ( i === result.currentIdx ) {
							$htmlLi = $htmlLi.add('<li><button type="button" value="'+i+'" aria-label="Page '+i+'" class="active" aria-current="page" disabled>'+i+'</button></li>');
						} else {
							$htmlLi = $htmlLi.add('<li><button type="button" value="'+i+'" aria-label="Page '+i+'">'+i+'</button></li>');
						}
					}
				}			
				// console.log($htmlLi);
				$pgUl.empty().append($htmlLi);
				if (pageLength >= 6 ) {
					$pgWrap.find('button.prev').prop("disabled", true);
					
					var las = pageLength - (pageLength % 5) + ( (pageLength % 5)==0?-4:1);
					if( i2 < las ){
						$pgWrap.find('button.next').prop("disabled", false);
						$pgUl.append('<li>...  <button type="button" value="'+pageLength+'" aria-label="Page '+pageLength+'">'+pageLength+'</button></li>');
					}else{
						$pgWrap.find('button.next').prop("disabled", true);
					}
				} else {
					$pgWrap.find('button.prev, button.next').prop("disabled", true);
				}
				if( f > 5 ) {
					$pgWrap.find('button.prev').prop("disabled", false);
				}
				
				//console.log("resogetTotalNum > "+pageLength +" : "+result.currentIdx);
				if( pageLength <= result.currentIdx ) {
					$pgWrap.find('button.next').prop("disabled", true);
				}
				$pgWrap.find('button.prev').val(f);
				$pgWrap.find('button.next').val(result.resogetTotalNum);
			},
			listShow : function (data, listAmount, totalNum){
				//console.log(data);
				
				var HTML = compressorMotor.html;
				var M_HTML = compressorMotor.mobileHtml;
				var i = 0;
				var img_path = "";
				var img_alt = "";
				
				//console.log("i >> "+i);
				for(i;i<data.length;i++){
					if ( data[i].fileType ==='PDF'){ img_alt = "File PDF";img_path="/lg5-common-gp/images/common/icons/file-pdf.png"}
					else if ( data[i].fileType ==='ZIP'){ img_alt = "File ZIP";img_path="/lg5-common-gp/images/common/icons/file-zip.png" }
					else if ( data[i].fileType ==='TXT'){ img_alt = "File TXT";img_path="/lg5-common-gp/images/common/icons/file-txt.png" }
					else if ( data[i].fileType ==='HTML'){ img_alt = "File HTML"; img_path="/lg5-common-gp/images/common/icons/file-html.png"}
					else if ( data[i].fileType ==='DJVU'){ img_alt = "File DJVU";img_path="/lg5-common-gp/images/common/icons/file-djvu.png" }
					else if ( data[i].fileType ==='DWG'){ img_alt = "File DWG";img_path="/lg5-common-gp/images/common/icons/file-dwg.png" }
					else { img_path = "/lg5-common-gp/images/common/icons/file-etc.png";img_alt="File '"+data[i].fileType+"'"}
					
					icon_title = data[i].fileType;
					
					HTML = HTML.add( 
							'<tr><td class="res-type">'+(data[i].resourceTypeName)+'</td>'
							+'<td class="cell-download"><a href="'+(data[i].fileUrl)+'" class="link-text lg ico-download compressorMotorDownload" download="'+(data[i].fileName)+'" data-fseqno="'+(data[i].fseqno)+'">'+(data[i].resourceTitle)+'</a></td>'
							+'<td><img src="'+img_path+'" class="img-icon" alt="'+img_alt+'">'+(data[i].fileSize)+'</td>'
							+'</tr>'
					);
					
				} 
				$('.table-list tbody').empty().append(HTML);

				if( listAmount >= totalNum){
					$('.data-page-length').text(totalNum);
					$('.expander').hide();
				}else{
					$('.data-page-length').text(listAmount);
					$('.expander').show();
				}
				$('.data-length').text(totalNum);
			}
		}
	compressorMotor.init();
});
